export default __webpack_public_path__ + "static/with-dog-0b09bb0d1da9e364b057fec62608a420.jpg";